import {Tooltip, Whisper} from "rsuite";
import React from "react";

export const Help = ({children}) => (
    <Whisper trigger="hover" speaker={<Tooltip>{children}</Tooltip>}>
        <span className="fa fa-circle-question"/>
    </Whisper>
);

export default Help;
